import React from 'react';
import styled from 'styled-components';
import logoSvg from '../assets/logo.svg';

interface LogoProps {
  variant?: 'default' | 'compact';
  size?: 'small' | 'medium' | 'large';
  vertical?: boolean;
}

const LogoWrapper = styled.div<{ $size: string }>`
  display: flex;
  align-items: center;
  gap: ${props => props.$size === 'small' ? '4px' : props.$size === 'large' ? '12px' : '10px'};
`;

const LogoImg = styled.img<{ $size: string }>`
  width: ${props => props.$size === 'small' ? '24px' : props.$size === 'large' ? '48px' : '36px'};
  height: ${props => props.$size === 'small' ? '24px' : props.$size === 'large' ? '48px' : '36px'};
`;

const LogoText = styled.div<{ $size: string; $vertical?: boolean }>`
  font-family: var(--font-family-secondary);
  font-weight: 600;
  font-size: ${props => props.$size === 'small' ? '16px' : props.$size === 'large' ? '28px' : '20px'};
  line-height: 1;
  color: var(--color-text);
  display: ${props => props.$vertical ? 'flex' : 'inline'};
  flex-direction: ${props => props.$vertical ? 'column' : 'row'};
  gap: ${props => props.$vertical ? '4px' : '0'};
  white-space: ${props => props.$vertical ? 'normal' : 'nowrap'};
`;

const ProText = styled.span<{ $vertical?: boolean }>`
  color: #24BA7D;
  display: inline-block;
  margin-left: ${props => props.$vertical ? '0' : '4px'};
`;

export const Logo: React.FC<LogoProps> = ({
  variant = 'default',
  size = 'medium',
  vertical = false
}) => {
  return (
    <LogoWrapper $size={size}>
      <LogoImg src={logoSvg} alt="Legit Fam Pro Logo" $size={size} />
      {variant === 'default' && (
        <LogoText $size={size} $vertical={vertical}>
          Legit Fam
          <ProText $vertical={vertical}>Pro</ProText>
        </LogoText>
      )}
    </LogoWrapper>
  );
};

export default Logo; 